import { render, staticRenderFns } from "./VentanaOperacionesCambios.vue?vue&type=template&id=30d2f84a"
import script from "./VentanaOperacionesCambios.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports